import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

/** Legacy mock plans page — fan subscriptions are managed in the main app. */
export default function Plans() {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title>Subscription Plans | TLK</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1 p-4 pb-24 md:pb-6 md:p-6">
                <div className="w-full max-w-lg mx-auto text-center">
                    <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                        Subscription plans
                    </h1>
                    <p className="text-foreground/70 text-sm md:text-base mb-6">
                        Fans subscribe through the TLK app. Creators typically offer a single
                        Premium plan (e.g. $19.99/month). Manage pricing in your creator settings
                        or contact support to update your plan.
                    </p>
                    <button
                        type="button"
                        className="inline-flex items-center justify-center rounded-full px-8 py-3 bg-primary text-primary-foreground font-semibold"
                        onClick={() => navigate(-1)}
                    >
                        Go back
                    </button>
                </div>
            </div>
        </>
    );
}
